import { render } from "./FullScreen.vue?vue&type=template&id=7ac85906"
import script from "./FullScreen.vue?vue&type=script&lang=ts"
export * from "./FullScreen.vue?vue&type=script&lang=ts"
script.render = render

export default script